export function initCreationsFilter() {
  var creationsGrid = document.getElementById('mj-creations-grid');
  var filterCat = document.getElementById('mj-creations-filter-cat');
  var filterTag = document.getElementById('mj-creations-filter-tag');

  if (!creationsGrid || (!filterCat && !filterTag)) return;

  var items = creationsGrid.querySelectorAll('.mj-creations-page__item');
  var activeFilters = { category: '*', tag: '*' };

  var applyFilters = function () {
    items.forEach(function (item) {
      var matchCat = activeFilters.category === '*' || item.classList.contains(activeFilters.category.substring(1));
      var matchTag = activeFilters.tag === '*' || item.classList.contains(activeFilters.tag.substring(1));
      item.style.display = (matchCat && matchTag) ? '' : 'none';
    });
    if (window.ScrollTrigger) window.ScrollTrigger.refresh();
  };

  var setupGroup = function (el, groupKey) {
    if (!el) return;
    var btns = el.querySelectorAll('.mj-creations-page__filter-btn');
    btns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var filter = btn.getAttribute('data-filter');
        activeFilters[groupKey] = filter;
        btns.forEach(function (b) {
          b.classList.toggle('is-active', b === btn);
          b.setAttribute('aria-selected', b === btn ? 'true' : 'false');
        });
        applyFilters();
      });
    });
  };

  setupGroup(filterCat, 'category');
  setupGroup(filterTag, 'tag');
}
